import template from './synonym-list.html.twig';
import '../../component/synonym-form';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-es-synonym-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'term',
            sortDirection: 'ASC',
            limit: 25,
            activeModal: false,
            currentEntity: null,
            showDeleteModal: false,
            itemToDelete: null,
            filterScope: null,
            filterSource: null,
            filterLanguage: null,
        };
    },

    computed: {
        deleteConfirmText() {
            if (!this.itemToDelete) return '';
            return this.$t('TopdataEnhancedSearchSW6.topdata-es-synonym.deleteConfirmText', { term: this.itemToDelete.term });
        },

        repository() {
            return this.repositoryFactory.create('tdes_synonym');
        },

        scopeOptions() {
            return [{
                value: 'GLOBAL',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeBoth'),
            }, {
                value: 'PRODUCT',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeProduct'),
            }, {
                value: 'CATEGORY',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeCategory'),
            }];
        },

        sourceOptions() {
            return [{
                value: 'MANUAL',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceManual'),
            }, {
                value: 'MPN_AUTO',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceMpnAuto'),
            }, {
                value: 'APPROVED_SUGGESTION',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceApprovedSuggestion'),
            }, {
                value: 'CSV_IMPORT',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceCsvImport'),
            }];
        },

        languageOptions() {
            return [{
                value: null,
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.filterLanguageAll'),
            }, {
                value: 'de',
                label: 'Deutsch',
            }, {
                value: 'en',
                label: 'English',
            }, {
                value: 'fr',
                label: 'Français',
            }, {
                value: 'NULL',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.filterLanguageGlobal'),
            }];
        },

        columns() {
            return [{
                property: 'term',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.columnTerm'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'synonyms',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.columnSynonyms'),
                allowResize: true,
            }, {
                property: 'scope',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.columnScope'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'languageId',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.columnLanguage'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'source',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.columnSource'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'boostLevel',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.columnBoostLevel'),
            }, {
                property: 'createdAt',
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.columnCreatedAt'),
                allowResize: true,
                sortable: true,
            }];
        },

    },

    mounted() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            if (this.term) {
                criteria.setTerm(this.term);
            }

            if (this.filterScope) {
                criteria.addFilter(Criteria.equals('scope', this.filterScope));
            }
            if (this.filterSource) {
                criteria.addFilter(Criteria.equals('source', this.filterSource));
            }
            if (this.filterLanguage) {
                if (this.filterLanguage === 'NULL') {
                    criteria.addFilter(Criteria.equals('languageId', null));
                } else {
                    criteria.addFilter(Criteria.equals('languageId', this.filterLanguage));
                }
            }

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        onAddSynonym() {
            this.currentEntity = this.repository.create();
            this.currentEntity.term = '';
            this.currentEntity.synonyms = '';
            this.currentEntity.scope = 'GLOBAL';
            this.currentEntity.languageId = null;
            this.currentEntity.source = 'MANUAL';
            this.currentEntity.boostLevel = 'NONE';
            this.activeModal = true;
        },

        onEditSynonym(item) {
            this.repository.get(item.id).then((entity) => {
                this.currentEntity = entity;
                this.activeModal = true;
            });
        },

        onCloseModal() {
            this.activeModal = false;
            this.currentEntity = null;
            this.getList();
        },

        onShowDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onDownloadCsv() {
            const httpClient = Shopware.Application.getContainer('init').httpClient;
            httpClient.get('_action/topdata-enhanced-search-sw6/synonyms/export', {
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'synonyms.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(() => {
                this.createNotificationError({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.exportError'),
                });
            });
        },

        onConfirmDelete() {
            this.repository.delete(this.itemToDelete.id).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.deleteSuccess'),
                });
                this.onCloseDeleteModal();
                this.getList();
            }).catch(() => {
                this.onCloseDeleteModal();
            });
        },

        getSourceVariant(source: string): string {
            const variants: Record<string, string> = {
                'MANUAL': 'neutral',
                'MPN_AUTO': 'info',
                'APPROVED_SUGGESTION': 'success',
                'CSV_IMPORT': 'warning',
            };
            return variants[source] || 'neutral';
        },

        getSourceLabel(source: string): string {
            const labels: Record<string, string> = {
                'MANUAL': this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceManual'),
                'MPN_AUTO': this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceMpnAuto'),
                'APPROVED_SUGGESTION': this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceApprovedSuggestion'),
                'CSV_IMPORT': this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.sourceCsvImport'),
            };
            return labels[source] || source;
        },

        getLanguageLabel(languageId: string | null): string {
            if (!languageId) {
                return this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.languageGlobal');
            }
            const labels: Record<string, string> = {
                'de': 'Deutsch',
                'en': 'English',
                'fr': 'Français',
            };
            return labels[languageId] || languageId;
        },

        onFilterChange() {
            this.page = 1;
            this.getList();
        },
    },
});
